import { render, staticRenderFns } from "./get-verified-prompt.vue?vue&type=template&id=57e10218&scoped=true&"
import script from "./get-verified-prompt.vue?vue&type=script&lang=js&"
export * from "./get-verified-prompt.vue?vue&type=script&lang=js&"
import style0 from "./get-verified-prompt.vue?vue&type=style&index=0&id=57e10218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e10218",
  null
  
)

export default component.exports